import { imageApi } from "../hooks";
import placeholder from "../assets/images/promotionPlaceholderImage.png";

export const isGiftPromotion = (promotion) =>
    (promotion.provider_type ?? promotion.providor_type) === "GIFT";

export function getSpinImage(promotion) {
    if (promotion.image) {
        return /^https?:\/\//.test(promotion.image)
            ? promotion.image
            : `${imageApi}/${promotion.image}`;
    }
    return promotion.product?.imageUrl || null;
}

export function getPromotionDisplay(promotion) {
    if (isGiftPromotion(promotion)) {
        return {
            title: promotion.product?.nameMyanmar || promotion.product?.name || "Gift",
            image: promotion.product?.imageUrl || placeholder,
        };
    }
    return {
        title: promotion.title,
        image: promotion.image
            ? (/^https?:\/\//.test(promotion.image) ? promotion.image : `${imageApi}/${promotion.image}`)
            : placeholder,
    };
}

export function imageFallback(event) {
    event.currentTarget.onerror = null;
    event.currentTarget.src = placeholder;
}

export function appendGiftProduct(formData, product) {
    if (!Number.isInteger(Number(product?.id)) || Number(product.id) <= 0) {
        throw new Error("Please select a Bahozay product.");
    }
    for (const key of ["id", "name", "nameMyanmar", "imageUrl"]) {
        formData.set(`product[${key}]`, String(product[key] ?? ""));
    }
    formData.delete("image");
    formData.set("title", product.nameMyanmar || product.name || "Gift");
    for (const key of ["amount", "percent", "points", "tokens"]) formData.set(key, 0);
    formData.set("promotion_id", "");
}

export const promotionSaveError = (error) => {
    const errors = error?.errors || {};
    return Object.values(errors).flat().join(" ") || error?.message || "Unable to save promotion. Please try again.";
};
